<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="page-header">
        <h2>{{funcao.descricao}}</h2>
      </div>
    </div>

    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-12">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Descrição</th>
                <th>Ações Disponíveis</th>
              </tr>
            </thead>

            <tbody>
              <tr ng-repeat="item in funcao.itens">
                <td>{{item.descricao | humanize}}</td>
                <td>{{item.acoes | filter:{permitir:true} | getTextItems}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row pull-right" ng-include="'views/funcoes/_show_buttons.html'"></div>
    </div>
  </div>
</page-data-manager>
